import { Box, Divider } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { OverviewSection, OverviewSectionSkins } from '@wix/rules-panel-ui';
import React from 'react';
import { ManualTask } from '../components/manual-task';
import { useA11yWizardAdapter } from '../hooks/use-a11y-wizard-adapter';
export const A11yWizardManualTasksTab = _ref => {
  let {
    issuesNumber,
    manualTasks
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const usesClassicModalChrome = capabilities.usesClassicModalChrome;
  const contentPadding = usesClassicModalChrome ? 'SP3' : '18px 20px';
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D80",
    direction: "vertical",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D80",
    padding: contentPadding
  }, /*#__PURE__*/React.createElement(OverviewSection, {
    description: t('accessibility-wizard.manual-tasks.overview-section.description'),
    detectedIssues: issuesNumber,
    showShadow: !compactPanelChrome,
    skin: OverviewSectionSkins.neutral,
    title: t('accessibility-wizard.manual-tasks.overview-section.title', {
      count: issuesNumber
    })
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D80",
    direction: "vertical",
    padding: usesClassicModalChrome ? 'SP3' : '18px 20px'
  }, manualTasks.map((item, index) => /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    paddingBottom: "SP3"
  }, index !== 0 && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ManualTask, item)))));
};
//# sourceMappingURL=a11y-wizard-manual-tasks-tab.js.map